/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import TitleField from '@folio/inventory/src/components/TitleField';
import { Col, Row } from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import HelpeModal from '../../HelpeModal';
import css from '../styles.css';

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  fieldName: PropTypes.string,
  parentField: PropTypes.object,
  showHelpeIcon: PropTypes.bool,
  fields: PropTypes.object,
};

function CustomTitleFieldComponent({
  fieldValues,
  index,
  fieldName,
  parentField,
  showHelpeIcon,
  fields,
}) {
  const { label, canEdit, helpeText, name } = fieldValues;

  const intl = useIntl();
  const fieldLabel = label.find((field) => field.locale === intl.locale)?.value;

  return (
    <Row>
      <Col xs={showHelpeIcon ? 11 : 12}>
        <TitleField
          field={fieldName}
          index={index}
          fields={fields}
          isDisabled={!canEdit}
          titleIdKey={
            parentField.name.startsWith('preceding')
              ? 'precedingInstanceId'
              : 'succeedingInstanceId'
          }
        />
      </Col>
      {showHelpeIcon && (
        <Col xs={1} className={css.margin_btn}>
          <HelpeModal
            fieldData={fieldValues}
            title={fieldLabel}
            iconSize="medium"
          />
        </Col>
      )}
    </Row>
  );
}

CustomTitleFieldComponent.propTypes = propTypes;

export default CustomTitleFieldComponent;
